var map = {
	"./003-Bigger-Than/BiggerThan": "62ee",
	"./003-Bigger-Than/BiggerThan.vue": "62ee",
	"./003-Bigger-Than/src/animations/answer-result": "bc74",
	"./003-Bigger-Than/src/animations/answer-result.js": "bc74",
	"./003-Bigger-Than/src/animations/bird": "9667",
	"./003-Bigger-Than/src/animations/bird.js": "9667",
	"./003-Bigger-Than/src/animations/crocodile": "402f",
	"./003-Bigger-Than/src/animations/crocodile.js": "402f",
	"./003-Bigger-Than/src/animations/dragonfly": "984a",
	"./003-Bigger-Than/src/animations/dragonfly.js": "984a",
	"./003-Bigger-Than/src/animations/frog": "d374",
	"./003-Bigger-Than/src/animations/frog.js": "d374",
	"./003-Bigger-Than/src/game": "c622",
	"./003-Bigger-Than/src/game.js": "c622",
	"./003-Bigger-Than/src/scenes/main": "d29b",
	"./003-Bigger-Than/src/scenes/main.js": "d29b",
	"./003-Bigger-Than/src/scenes/preloader": "20251",
	"./003-Bigger-Than/src/scenes/preloader.js": "20251",
	"./003-Bigger-Than/src/ui/stars": "cd90",
	"./003-Bigger-Than/src/ui/stars.js": "cd90",
	"./005-Shape-Names/ShapeNames": "abd3",
	"./005-Shape-Names/ShapeNames.vue": "abd3",
	"./005-Shape-Names/src/animations/airplane": "d02b",
	"./005-Shape-Names/src/animations/airplane.js": "d02b",
	"./005-Shape-Names/src/animations/background": "2eb7",
	"./005-Shape-Names/src/animations/background.js": "2eb7",
	"./005-Shape-Names/src/animations/birds": "dada",
	"./005-Shape-Names/src/animations/birds.js": "dada",
	"./005-Shape-Names/src/animations/clouds": "17de",
	"./005-Shape-Names/src/animations/clouds.js": "17de",
	"./005-Shape-Names/src/game": "c70a",
	"./005-Shape-Names/src/game.js": "c70a",
	"./005-Shape-Names/src/scenes/main": "7010",
	"./005-Shape-Names/src/scenes/main.js": "7010",
	"./005-Shape-Names/src/scenes/preloader": "645b",
	"./005-Shape-Names/src/scenes/preloader.js": "645b",
	"./008-Letters-Alphabetical/LettersAlphabetical": "2a2b",
	"./008-Letters-Alphabetical/LettersAlphabetical.vue": "2a2b",
	"./008-Letters-Alphabetical/src/animations/question": "e02a",
	"./008-Letters-Alphabetical/src/animations/question.js": "e02a",
	"./008-Letters-Alphabetical/src/game": "382a",
	"./008-Letters-Alphabetical/src/game.js": "382a",
	"./008-Letters-Alphabetical/src/scenes/main": "c7d3",
	"./008-Letters-Alphabetical/src/scenes/main.js": "c7d3",
	"./008-Letters-Alphabetical/src/scenes/preloader": "f3de",
	"./008-Letters-Alphabetical/src/scenes/preloader.js": "f3de",
	"./009-Counting-Up-Down/CountingUpDown": "a634",
	"./009-Counting-Up-Down/CountingUpDown.vue": "a634",
	"./009-Counting-Up-Down/src/animations/asteroid": "db2a",
	"./009-Counting-Up-Down/src/animations/asteroid.js": "db2a",
	"./009-Counting-Up-Down/src/animations/cat": "c8f9",
	"./009-Counting-Up-Down/src/animations/cat.js": "c8f9",
	"./009-Counting-Up-Down/src/animations/comet": "7615",
	"./009-Counting-Up-Down/src/animations/comet.js": "7615",
	"./009-Counting-Up-Down/src/animations/digit": "f7aa",
	"./009-Counting-Up-Down/src/animations/digit.js": "f7aa",
	"./009-Counting-Up-Down/src/animations/question": "9184",
	"./009-Counting-Up-Down/src/animations/question.js": "9184",
	"./009-Counting-Up-Down/src/game": "2261",
	"./009-Counting-Up-Down/src/game.js": "2261",
	"./009-Counting-Up-Down/src/scenes/main": "e9e1",
	"./009-Counting-Up-Down/src/scenes/main.js": "e9e1",
	"./009-Counting-Up-Down/src/scenes/preloader": "1321",
	"./009-Counting-Up-Down/src/scenes/preloader.js": "1321",
	"./010-Number-Names/NumberNames": "0af1",
	"./010-Number-Names/NumberNames.vue": "0af1",
	"./010-Number-Names/src/animations/number": "dc2b",
	"./010-Number-Names/src/animations/number.js": "dc2b",
	"./010-Number-Names/src/answer": "78cd",
	"./010-Number-Names/src/answer.js": "78cd",
	"./010-Number-Names/src/game": "e0f9",
	"./010-Number-Names/src/game.js": "e0f9",
	"./010-Number-Names/src/scenes/main": "fa1b",
	"./010-Number-Names/src/scenes/main.js": "fa1b",
	"./010-Number-Names/src/scenes/preloader": "d8b4",
	"./010-Number-Names/src/scenes/preloader.js": "d8b4",
	"./011-Biggest-Smallest-Shapes/BiggestSmallestShapes": "9d75",
	"./011-Biggest-Smallest-Shapes/BiggestSmallestShapes.vue": "9d75",
	"./011-Biggest-Smallest-Shapes/src/animations/castle": "7fe3",
	"./011-Biggest-Smallest-Shapes/src/animations/castle.js": "7fe3",
	"./011-Biggest-Smallest-Shapes/src/animations/shape": "a62b",
	"./011-Biggest-Smallest-Shapes/src/animations/shape.js": "a62b",
	"./011-Biggest-Smallest-Shapes/src/game": "15d8",
	"./011-Biggest-Smallest-Shapes/src/game.js": "15d8",
	"./011-Biggest-Smallest-Shapes/src/scenes/main": "5916",
	"./011-Biggest-Smallest-Shapes/src/scenes/main.js": "5916",
	"./011-Biggest-Smallest-Shapes/src/scenes/preloader": "d093",
	"./011-Biggest-Smallest-Shapes/src/scenes/preloader.js": "d093",
	"./017-Counting-Dots/CountingDots": "8319",
	"./017-Counting-Dots/CountingDots.vue": "8319",
	"./017-Counting-Dots/src/answer": "4718",
	"./017-Counting-Dots/src/answer.js": "4718",
	"./017-Counting-Dots/src/answers-box": "91c3",
	"./017-Counting-Dots/src/answers-box.js": "91c3",
	"./017-Counting-Dots/src/dot-box": "5036",
	"./017-Counting-Dots/src/dot-box.js": "5036",
	"./017-Counting-Dots/src/game": "b766",
	"./017-Counting-Dots/src/game.js": "b766",
	"./017-Counting-Dots/src/scenes/main": "e266",
	"./017-Counting-Dots/src/scenes/main.js": "e266",
	"./017-Counting-Dots/src/scenes/preloader": "5edf",
	"./017-Counting-Dots/src/scenes/preloader.js": "5edf",
	"./022-Synonym-Rolls/SynonymRolls": "8069",
	"./022-Synonym-Rolls/SynonymRolls.vue": "8069",
	"./022-Synonym-Rolls/src/animations/wiggle": "5e00",
	"./022-Synonym-Rolls/src/animations/wiggle.js": "5e00",
	"./022-Synonym-Rolls/src/game": "caac",
	"./022-Synonym-Rolls/src/game.js": "caac",
	"./022-Synonym-Rolls/src/scenes/boot": "f0f5",
	"./022-Synonym-Rolls/src/scenes/boot.js": "f0f5",
	"./022-Synonym-Rolls/src/scenes/intro/intro": "03dd",
	"./022-Synonym-Rolls/src/scenes/intro/intro.js": "03dd",
	"./022-Synonym-Rolls/src/scenes/main": "7e89",
	"./022-Synonym-Rolls/src/scenes/main.js": "7e89",
	"./022-Synonym-Rolls/src/scenes/preloader": "51db",
	"./022-Synonym-Rolls/src/scenes/preloader.js": "51db",
	"./024-Identify-The-Feeling/IdentifyTheFeeling": "a20d",
	"./024-Identify-The-Feeling/IdentifyTheFeeling.vue": "a20d",
	"./024-Identify-The-Feeling/src/game": "d26f",
	"./024-Identify-The-Feeling/src/game.js": "d26f",
	"./024-Identify-The-Feeling/src/scenes/main": "0939",
	"./024-Identify-The-Feeling/src/scenes/main.js": "0939",
	"./024-Identify-The-Feeling/src/scenes/preloader": "8e25",
	"./024-Identify-The-Feeling/src/scenes/preloader.js": "8e25",
	"./033-Count-By-Dragging/CountByDragging": "9272",
	"./033-Count-By-Dragging/CountByDragging.vue": "9272",
	"./033-Count-By-Dragging/src/game": "7910",
	"./033-Count-By-Dragging/src/game.js": "7910",
	"./033-Count-By-Dragging/src/scenes/boot": "f2d9",
	"./033-Count-By-Dragging/src/scenes/boot.js": "f2d9",
	"./033-Count-By-Dragging/src/scenes/main": "8235",
	"./033-Count-By-Dragging/src/scenes/main.js": "8235",
	"./033-Count-By-Dragging/src/scenes/preloader": "b860",
	"./033-Count-By-Dragging/src/scenes/preloader.js": "b860",
	"./044-Count-Along/CountAlong": "a8f4",
	"./044-Count-Along/CountAlong.vue": "a8f4",
	"./044-Count-Along/src/animations/butterfly": "3182e",
	"./044-Count-Along/src/animations/butterfly.js": "3182e",
	"./044-Count-Along/src/animations/chick": "7b3c",
	"./044-Count-Along/src/animations/chick.js": "7b3c",
	"./044-Count-Along/src/animations/chicken-duck": "a33b",
	"./044-Count-Along/src/animations/chicken-duck.js": "a33b",
	"./044-Count-Along/src/animations/move-animals2": "a356e",
	"./044-Count-Along/src/animations/move-animals2.js": "a356e",
	"./044-Count-Along/src/animations/rabbit": "26f4",
	"./044-Count-Along/src/animations/rabbit.js": "26f4",
	"./044-Count-Along/src/animations/squirrel": "e495",
	"./044-Count-Along/src/animations/squirrel.js": "e495",
	"./044-Count-Along/src/game": "026a",
	"./044-Count-Along/src/game.js": "026a",
	"./044-Count-Along/src/scenes/main": "650e",
	"./044-Count-Along/src/scenes/main.js": "650e",
	"./044-Count-Along/src/scenes/preloader": "9867",
	"./044-Count-Along/src/scenes/preloader.js": "9867",
	"./045-Translate-Ten-Frame-To-Number/TranslateTenFrameToNumber": "79b1",
	"./045-Translate-Ten-Frame-To-Number/TranslateTenFrameToNumber.vue": "79b1",
	"./045-Translate-Ten-Frame-To-Number/src/game": "b244",
	"./045-Translate-Ten-Frame-To-Number/src/game.js": "b244",
	"./045-Translate-Ten-Frame-To-Number/src/scenes/main": "5b38",
	"./045-Translate-Ten-Frame-To-Number/src/scenes/main.js": "5b38",
	"./045-Translate-Ten-Frame-To-Number/src/scenes/preloader": "91db",
	"./045-Translate-Ten-Frame-To-Number/src/scenes/preloader.js": "91db",
	"./046-Translate-Number-To-Ten-Frame/TranslateNumberToTenFrame": "11c1",
	"./046-Translate-Number-To-Ten-Frame/TranslateNumberToTenFrame.vue": "11c1",
	"./046-Translate-Number-To-Ten-Frame/src/game": "25d8",
	"./046-Translate-Number-To-Ten-Frame/src/game.js": "25d8",
	"./046-Translate-Number-To-Ten-Frame/src/scenes/main": "494c",
	"./046-Translate-Number-To-Ten-Frame/src/scenes/main.js": "494c",
	"./046-Translate-Number-To-Ten-Frame/src/scenes/preloader": "996f",
	"./046-Translate-Number-To-Ten-Frame/src/scenes/preloader.js": "996f",
	"./047-Identify-The-Season/IdentifyTheSeason": "97c2",
	"./047-Identify-The-Season/IdentifyTheSeason.vue": "97c2",
	"./047-Identify-The-Season/src/game": "efd9",
	"./047-Identify-The-Season/src/game.js": "efd9",
	"./047-Identify-The-Season/src/scenes/main": "705d",
	"./047-Identify-The-Season/src/scenes/main.js": "705d",
	"./047-Identify-The-Season/src/scenes/preloader": "873a",
	"./047-Identify-The-Season/src/scenes/preloader.js": "873a",
	"./048-Seasons-Ordering/SeasonsOrdering": "cd0d",
	"./048-Seasons-Ordering/SeasonsOrdering.vue": "cd0d",
	"./048-Seasons-Ordering/src/game": "bfab",
	"./048-Seasons-Ordering/src/game.js": "bfab",
	"./048-Seasons-Ordering/src/scenes/main": "27d6",
	"./048-Seasons-Ordering/src/scenes/main.js": "27d6",
	"./048-Seasons-Ordering/src/scenes/preloader": "9b0f",
	"./048-Seasons-Ordering/src/scenes/preloader.js": "9b0f",
	"./056-Complete-The-Rhyme/CompleteTheRhyme": "d22f",
	"./056-Complete-The-Rhyme/CompleteTheRhyme.vue": "d22f",
	"./056-Complete-The-Rhyme/src/game": "72dc",
	"./056-Complete-The-Rhyme/src/game.js": "72dc",
	"./056-Complete-The-Rhyme/src/scenes/main": "b278",
	"./056-Complete-The-Rhyme/src/scenes/main.js": "b278",
	"./056-Complete-The-Rhyme/src/scenes/preloader": "b5ab",
	"./056-Complete-The-Rhyme/src/scenes/preloader.js": "b5ab",
	"./058-Identify-Grid-Positions/IdentifyGridPositions": "3ffc",
	"./058-Identify-Grid-Positions/IdentifyGridPositions.vue": "3ffc",
	"./058-Identify-Grid-Positions/src/game": "e5c3",
	"./058-Identify-Grid-Positions/src/game.js": "e5c3",
	"./058-Identify-Grid-Positions/src/scenes/main": "565a",
	"./058-Identify-Grid-Positions/src/scenes/main.js": "565a",
	"./058-Identify-Grid-Positions/src/scenes/preloader": "3c33",
	"./058-Identify-Grid-Positions/src/scenes/preloader.js": "3c33",
	"./059-Count-The-Tally-Marks/CountTheTallyMarks": "2bda",
	"./059-Count-The-Tally-Marks/CountTheTallyMarks.vue": "2bda",
	"./059-Count-The-Tally-Marks/src/game": "0f4f",
	"./059-Count-The-Tally-Marks/src/game.js": "0f4f",
	"./059-Count-The-Tally-Marks/src/scenes/main": "33ac",
	"./059-Count-The-Tally-Marks/src/scenes/main.js": "33ac",
	"./059-Count-The-Tally-Marks/src/scenes/preloader": "e58a",
	"./059-Count-The-Tally-Marks/src/scenes/preloader.js": "e58a",
	"./Basketball-Binary/BasketballBinary": "ac74",
	"./Basketball-Binary/BasketballBinary.vue": "ac74",
	"./Basketball-Binary/src/game": "e641",
	"./Basketball-Binary/src/game.js": "e641",
	"./Basketball-Binary/src/scenes/main": "ee17",
	"./Basketball-Binary/src/scenes/main.js": "ee17",
	"./Basketball-Binary/src/scenes/preloader": "fbac",
	"./Basketball-Binary/src/scenes/preloader.js": "fbac",
	"./Binary-Text-To-Image/BinaryTextToImage": "5a59",
	"./Binary-Text-To-Image/BinaryTextToImage.vue": "5a59",
	"./Binary-Text-To-Image/src/game": "13fb",
	"./Binary-Text-To-Image/src/game.js": "13fb",
	"./Binary-Text-To-Image/src/scenes/main": "f65f",
	"./Binary-Text-To-Image/src/scenes/main.js": "f65f",
	"./Binary-Text-To-Image/src/scenes/preloader": "af7e",
	"./Binary-Text-To-Image/src/scenes/preloader.js": "af7e",
	"./Bowling-Binary-Answer/BowlingBinaryAnswer": "3bf4",
	"./Bowling-Binary-Answer/BowlingBinaryAnswer.vue": "3bf4",
	"./Bowling-Binary-Answer/src/game": "03f9",
	"./Bowling-Binary-Answer/src/game.js": "03f9",
	"./Bowling-Binary-Answer/src/scenes/main": "cce7",
	"./Bowling-Binary-Answer/src/scenes/main.js": "cce7",
	"./Bowling-Binary-Answer/src/scenes/preloader": "816c",
	"./Bowling-Binary-Answer/src/scenes/preloader.js": "816c",
	"./Bullseye-Match-Text/BullseyeMatchText": "0123",
	"./Bullseye-Match-Text/BullseyeMatchText.vue": "0123",
	"./Bullseye-Match-Text/src/game": "fe04",
	"./Bullseye-Match-Text/src/game.js": "fe04",
	"./Bullseye-Match-Text/src/scenes/main": "d058",
	"./Bullseye-Match-Text/src/scenes/main.js": "d058",
	"./Bullseye-Match-Text/src/scenes/preloader": "21b7",
	"./Bullseye-Match-Text/src/scenes/preloader.js": "21b7",
	"./Carousel-Image-Multi/CarouselImageMulti": "7edb",
	"./Carousel-Image-Multi/CarouselImageMulti.vue": "7edb",
	"./Carousel-Image-Multi/src/game": "9538",
	"./Carousel-Image-Multi/src/game.js": "9538",
	"./Carousel-Image-Multi/src/scenes/main": "4155",
	"./Carousel-Image-Multi/src/scenes/main.js": "4155",
	"./Carousel-Image-Multi/src/scenes/preloader": "7460",
	"./Carousel-Image-Multi/src/scenes/preloader.js": "7460",
	"./Categorization-Simple-Frame/CategorizationSimpleFrame": "80ef",
	"./Categorization-Simple-Frame/CategorizationSimpleFrame.vue": "80ef",
	"./Categorization-Simple-Frame/src/game": "fb93",
	"./Categorization-Simple-Frame/src/game.js": "fb93",
	"./Categorization-Simple-Frame/src/item/category-item": "2706",
	"./Categorization-Simple-Frame/src/item/category-item.js": "2706",
	"./Categorization-Simple-Frame/src/item/task-item": "6f7f",
	"./Categorization-Simple-Frame/src/item/task-item.js": "6f7f",
	"./Categorization-Simple-Frame/src/scenes/main": "53cf",
	"./Categorization-Simple-Frame/src/scenes/main.js": "53cf",
	"./Categorization-Simple-Frame/src/scenes/preloader": "6c83",
	"./Categorization-Simple-Frame/src/scenes/preloader.js": "6c83",
	"./Complete-To-10/CompleteTo10": "38be",
	"./Complete-To-10/CompleteTo10.vue": "38be",
	"./Complete-To-10/src/game": "97c1",
	"./Complete-To-10/src/game.js": "97c1",
	"./Complete-To-10/src/scenes/main": "8da1",
	"./Complete-To-10/src/scenes/main.js": "8da1",
	"./Complete-To-10/src/scenes/preloader": "f2d4",
	"./Complete-To-10/src/scenes/preloader.js": "f2d4",
	"./Copy-Pattern/CopyPattern": "8045",
	"./Copy-Pattern/CopyPattern.vue": "8045",
	"./Copy-Pattern/src/game": "d51a",
	"./Copy-Pattern/src/game.js": "d51a",
	"./Copy-Pattern/src/scenes/main": "489a",
	"./Copy-Pattern/src/scenes/main.js": "489a",
	"./Copy-Pattern/src/scenes/preloader": "0b2f",
	"./Copy-Pattern/src/scenes/preloader.js": "0b2f",
	"./Count-And-Compare-Groups/CountAndCompareGroups": "b9ff",
	"./Count-And-Compare-Groups/CountAndCompareGroups.vue": "b9ff",
	"./Count-And-Compare-Groups/src/game": "eed8",
	"./Count-And-Compare-Groups/src/game.js": "eed8",
	"./Count-And-Compare-Groups/src/scenes/main": "5e5a",
	"./Count-And-Compare-Groups/src/scenes/main.js": "5e5a",
	"./Count-And-Compare-Groups/src/scenes/preloader": "51bc",
	"./Count-And-Compare-Groups/src/scenes/preloader.js": "51bc",
	"./Count-Items-And-Increment/CountItemsAndIncrement": "751e",
	"./Count-Items-And-Increment/CountItemsAndIncrement.vue": "751e",
	"./Count-Items-And-Increment/src/game": "04ea",
	"./Count-Items-And-Increment/src/game.js": "04ea",
	"./Count-Items-And-Increment/src/scenes/main": "5c73",
	"./Count-Items-And-Increment/src/scenes/main.js": "5c73",
	"./Count-Items-And-Increment/src/scenes/preloader": "290f",
	"./Count-Items-And-Increment/src/scenes/preloader.js": "290f",
	"./Counting-Currency/CountingCurrency": "fde0",
	"./Counting-Currency/CountingCurrency.vue": "fde0",
	"./Counting-Currency/src/animations/pig-mistake": "c7af",
	"./Counting-Currency/src/animations/pig-mistake.js": "c7af",
	"./Counting-Currency/src/animations/pig-oink": "ad9b",
	"./Counting-Currency/src/animations/pig-oink.js": "ad9b",
	"./Counting-Currency/src/animations/question-mark": "3bc9",
	"./Counting-Currency/src/animations/question-mark.js": "3bc9",
	"./Counting-Currency/src/game": "7e79",
	"./Counting-Currency/src/game.js": "7e79",
	"./Counting-Currency/src/scenes/main": "6dfc",
	"./Counting-Currency/src/scenes/main.js": "6dfc",
	"./Counting-Currency/src/scenes/preloader": "fce7",
	"./Counting-Currency/src/scenes/preloader.js": "fce7",
	"./Counting-Items/CountingItems": "82fe",
	"./Counting-Items/CountingItems.vue": "82fe",
	"./Counting-Items/src/game": "9f19",
	"./Counting-Items/src/game.js": "9f19",
	"./Counting-Items/src/scenes/main": "ece8",
	"./Counting-Items/src/scenes/main.js": "ece8",
	"./Counting-Items/src/scenes/preloader": "3c8f",
	"./Counting-Items/src/scenes/preloader.js": "3c8f",
	"./Detective-Multiple-Choice/DetectiveMultipleChoice": "7c80",
	"./Detective-Multiple-Choice/DetectiveMultipleChoice.vue": "7c80",
	"./Detective-Multiple-Choice/src/game": "94ba",
	"./Detective-Multiple-Choice/src/game.js": "94ba",
	"./Detective-Multiple-Choice/src/scenes/main": "f5ac",
	"./Detective-Multiple-Choice/src/scenes/main.js": "f5ac",
	"./Detective-Multiple-Choice/src/scenes/preloader": "ece6",
	"./Detective-Multiple-Choice/src/scenes/preloader.js": "ece6",
	"./Drag-Images-To-Match/DragImagesToMatch": "4215",
	"./Drag-Images-To-Match/DragImagesToMatch.vue": "4215",
	"./Drag-Images-To-Match/src/game": "ebb7",
	"./Drag-Images-To-Match/src/game.js": "ebb7",
	"./Drag-Images-To-Match/src/item": "d59a",
	"./Drag-Images-To-Match/src/item.js": "d59a",
	"./Drag-Images-To-Match/src/scenes/main": "b2b7",
	"./Drag-Images-To-Match/src/scenes/main.js": "b2b7",
	"./Drag-Images-To-Match/src/scenes/preloader": "4265",
	"./Drag-Images-To-Match/src/scenes/preloader.js": "4265",
	"./Fill-In-The-Blanks/FillInTheBlanks": "67bc",
	"./Fill-In-The-Blanks/FillInTheBlanks.vue": "67bc",
	"./Fill-In-The-Blanks/src/game": "d4e0",
	"./Fill-In-The-Blanks/src/game.js": "d4e0",
	"./Fill-In-The-Blanks/src/scenes/main": "70f1",
	"./Fill-In-The-Blanks/src/scenes/main.js": "70f1",
	"./Fill-In-The-Blanks/src/scenes/preloader": "f74e",
	"./Fill-In-The-Blanks/src/scenes/preloader.js": "f74e",
	"./Image-Binary/ImageBinary": "1f25",
	"./Image-Binary/ImageBinary.vue": "1f25",
	"./Image-Binary/src/game": "eda1",
	"./Image-Binary/src/game.js": "eda1",
	"./Image-Binary/src/scenes/main": "a48a",
	"./Image-Binary/src/scenes/main.js": "a48a",
	"./Image-Binary/src/scenes/preloader": "df81",
	"./Image-Binary/src/scenes/preloader.js": "df81",
	"./Image-Multiselect-No-Question/ImageMultiselectNoQuestion": "6287",
	"./Image-Multiselect-No-Question/ImageMultiselectNoQuestion.vue": "6287",
	"./Image-Multiselect-No-Question/src/game": "7009",
	"./Image-Multiselect-No-Question/src/game.js": "7009",
	"./Image-Multiselect-No-Question/src/scenes/main": "3916",
	"./Image-Multiselect-No-Question/src/scenes/main.js": "3916",
	"./Image-Multiselect-No-Question/src/scenes/preloader": "c3b7",
	"./Image-Multiselect-No-Question/src/scenes/preloader.js": "c3b7",
	"./Image-Question-To-Images-Answers/ImageQuestionToImagesAnswers": "7f16",
	"./Image-Question-To-Images-Answers/ImageQuestionToImagesAnswers.vue": "7f16",
	"./Image-Question-To-Images-Answers/src/game": "8874",
	"./Image-Question-To-Images-Answers/src/game.js": "8874",
	"./Image-Question-To-Images-Answers/src/scenes/main": "f5c4",
	"./Image-Question-To-Images-Answers/src/scenes/main.js": "f5c4",
	"./Image-Question-To-Images-Answers/src/scenes/preloader": "b5ff",
	"./Image-Question-To-Images-Answers/src/scenes/preloader.js": "b5ff",
	"./Images-To-Text-Space/ImagesToTextSpace": "cab5",
	"./Images-To-Text-Space/ImagesToTextSpace.vue": "cab5",
	"./Images-To-Text-Space/src/answer": "a024",
	"./Images-To-Text-Space/src/answer.js": "a024",
	"./Images-To-Text-Space/src/game": "abc0",
	"./Images-To-Text-Space/src/game.js": "abc0",
	"./Images-To-Text-Space/src/question": "092b",
	"./Images-To-Text-Space/src/question.js": "092b",
	"./Images-To-Text-Space/src/rocket": "0864",
	"./Images-To-Text-Space/src/rocket.js": "0864",
	"./Images-To-Text-Space/src/scenes/main": "8451",
	"./Images-To-Text-Space/src/scenes/main.js": "8451",
	"./Images-To-Text-Space/src/scenes/preloader": "42bc",
	"./Images-To-Text-Space/src/scenes/preloader.js": "42bc",
	"./Images-To-Text-Space/src/scenes/rockets": "0a2e",
	"./Images-To-Text-Space/src/scenes/rockets.js": "0a2e",
	"./Match-Opposites/MatchOpposites": "6254",
	"./Match-Opposites/MatchOpposites.vue": "6254",
	"./Match-Opposites/src/animations/fly-to-screen": "2eae",
	"./Match-Opposites/src/animations/fly-to-screen.js": "2eae",
	"./Match-Opposites/src/animations/shake": "506d",
	"./Match-Opposites/src/animations/shake.js": "506d",
	"./Match-Opposites/src/game": "5152",
	"./Match-Opposites/src/game.js": "5152",
	"./Match-Opposites/src/scenes/main": "c669",
	"./Match-Opposites/src/scenes/main.js": "c669",
	"./Match-Opposites/src/scenes/preloader": "c7a5",
	"./Match-Opposites/src/scenes/preloader.js": "c7a5",
	"./Matching-Balloons/MatchingBalloons": "8ad2",
	"./Matching-Balloons/MatchingBalloons.vue": "8ad2",
	"./Matching-Balloons/src/animations/balloon-flying": "fe51",
	"./Matching-Balloons/src/animations/balloon-flying.js": "fe51",
	"./Matching-Balloons/src/game": "5fb3",
	"./Matching-Balloons/src/game.js": "5fb3",
	"./Matching-Balloons/src/scenes/main": "4a6f",
	"./Matching-Balloons/src/scenes/main.js": "4a6f",
	"./Matching-Balloons/src/scenes/preloader": "952a",
	"./Matching-Balloons/src/scenes/preloader.js": "952a",
	"./Matching-Chests/MatchingChests": "c63c",
	"./Matching-Chests/MatchingChests.vue": "c63c",
	"./Matching-Chests/src/animations/chest": "cdf5",
	"./Matching-Chests/src/animations/chest.js": "cdf5",
	"./Matching-Chests/src/clocks/analog": "2b61",
	"./Matching-Chests/src/clocks/analog.js": "2b61",
	"./Matching-Chests/src/clocks/digital": "90f8",
	"./Matching-Chests/src/clocks/digital.js": "90f8",
	"./Matching-Chests/src/game": "676c",
	"./Matching-Chests/src/game.js": "676c",
	"./Matching-Chests/src/scenes/main": "b80e",
	"./Matching-Chests/src/scenes/main.js": "b80e",
	"./Matching-Chests/src/scenes/preloader": "e578",
	"./Matching-Chests/src/scenes/preloader.js": "e578",
	"./Matching-Images-In-Group/MatchingImagesInGroup": "16be",
	"./Matching-Images-In-Group/MatchingImagesInGroup.vue": "16be",
	"./Matching-Images-In-Group/src/game": "72e7",
	"./Matching-Images-In-Group/src/game.js": "72e7",
	"./Matching-Images-In-Group/src/scenes/main": "72fd",
	"./Matching-Images-In-Group/src/scenes/main.js": "72fd",
	"./Matching-Images-In-Group/src/scenes/preloader": "20e2",
	"./Matching-Images-In-Group/src/scenes/preloader.js": "20e2",
	"./Matching-Letters-In-Group/MatchingLettersInGroup": "fb64",
	"./Matching-Letters-In-Group/MatchingLettersInGroup.vue": "fb64",
	"./Matching-Letters-In-Group/src/game": "302b",
	"./Matching-Letters-In-Group/src/game.js": "302b",
	"./Matching-Letters-In-Group/src/scenes/main": "1576",
	"./Matching-Letters-In-Group/src/scenes/main.js": "1576",
	"./Matching-Letters-In-Group/src/scenes/preloader": "2608",
	"./Matching-Letters-In-Group/src/scenes/preloader.js": "2608",
	"./Matching-Words/MatchingWords": "ded3",
	"./Matching-Words/MatchingWords.vue": "ded3",
	"./Matching-Words/src/game": "838e",
	"./Matching-Words/src/game.js": "838e",
	"./Matching-Words/src/scenes/main": "ccd6",
	"./Matching-Words/src/scenes/main.js": "ccd6",
	"./Matching-Words/src/scenes/preloader": "8d17",
	"./Matching-Words/src/scenes/preloader.js": "8d17",
	"./Missing-Letters/MissingLetters": "36fe",
	"./Missing-Letters/MissingLetters.vue": "36fe",
	"./Missing-Letters/src/game": "c679",
	"./Missing-Letters/src/game.js": "c679",
	"./Missing-Letters/src/scenes/main": "0742",
	"./Missing-Letters/src/scenes/main.js": "0742",
	"./Missing-Letters/src/scenes/preloader": "b67e",
	"./Missing-Letters/src/scenes/preloader.js": "b67e",
	"./Monkey-Images-To-Text/MonkeyImagesToText": "9d96",
	"./Monkey-Images-To-Text/MonkeyImagesToText.vue": "9d96",
	"./Monkey-Images-To-Text/src/game": "3ed6",
	"./Monkey-Images-To-Text/src/game.js": "3ed6",
	"./Monkey-Images-To-Text/src/scenes/main": "065e",
	"./Monkey-Images-To-Text/src/scenes/main.js": "065e",
	"./Monkey-Images-To-Text/src/scenes/preloader": "b1f9",
	"./Monkey-Images-To-Text/src/scenes/preloader.js": "b1f9",
	"./Multiple-Choice/MultipleChoice": "a8a8",
	"./Multiple-Choice/MultipleChoice.vue": "a8a8",
	"./Multiple-Choice/src/game": "0b13",
	"./Multiple-Choice/src/game.js": "0b13",
	"./Multiple-Choice/src/scenes/main": "380d",
	"./Multiple-Choice/src/scenes/main.js": "380d",
	"./Multiple-Choice/src/scenes/preloader": "7ca6",
	"./Multiple-Choice/src/scenes/preloader.js": "7ca6",
	"./Notes.txt": "58cb",
	"./Number-Grid/NumberGrid": "1c7b",
	"./Number-Grid/NumberGrid.vue": "1c7b",
	"./Number-Grid/src/game": "188d",
	"./Number-Grid/src/game.js": "188d",
	"./Number-Grid/src/scenes/main": "b391",
	"./Number-Grid/src/scenes/main.js": "b391",
	"./Number-Grid/src/scenes/preloader": "c2cd",
	"./Number-Grid/src/scenes/preloader.js": "c2cd",
	"./Number-Line-Simple-Missing/NumberLineSimpleMissing": "8f57",
	"./Number-Line-Simple-Missing/NumberLineSimpleMissing.vue": "8f57",
	"./Number-Line-Simple-Missing/src/game": "e79e",
	"./Number-Line-Simple-Missing/src/game.js": "e79e",
	"./Number-Line-Simple-Missing/src/scenes/main": "0fd5",
	"./Number-Line-Simple-Missing/src/scenes/main.js": "0fd5",
	"./Number-Line-Simple-Missing/src/scenes/preloader": "4d1b",
	"./Number-Line-Simple-Missing/src/scenes/preloader.js": "4d1b",
	"./Pirate-Chest-Positions/PirateChestPositions": "7aac",
	"./Pirate-Chest-Positions/PirateChestPositions.vue": "7aac",
	"./Pirate-Chest-Positions/src/game": "fd5b",
	"./Pirate-Chest-Positions/src/game.js": "fd5b",
	"./Pirate-Chest-Positions/src/scenes/main": "ada4",
	"./Pirate-Chest-Positions/src/scenes/main.js": "ada4",
	"./Pirate-Chest-Positions/src/scenes/preloader": "a491",
	"./Pirate-Chest-Positions/src/scenes/preloader.js": "a491",
	"./Pirates-Match-Text/PiratesMatchText": "90a1",
	"./Pirates-Match-Text/PiratesMatchText.vue": "90a1",
	"./Pirates-Match-Text/src/game": "a5ef",
	"./Pirates-Match-Text/src/game.js": "a5ef",
	"./Pirates-Match-Text/src/scenes/main": "ca06",
	"./Pirates-Match-Text/src/scenes/main.js": "ca06",
	"./Pirates-Match-Text/src/scenes/preloader": "2c77",
	"./Pirates-Match-Text/src/scenes/preloader.js": "2c77",
	"./Racecar-Image-Select/RacecarImageSelect": "2180",
	"./Racecar-Image-Select/RacecarImageSelect.vue": "2180",
	"./Racecar-Image-Select/src/game": "51d6",
	"./Racecar-Image-Select/src/game.js": "51d6",
	"./Racecar-Image-Select/src/scenes/main": "7f2d",
	"./Racecar-Image-Select/src/scenes/main.js": "7f2d",
	"./Racecar-Image-Select/src/scenes/preloader": "c972",
	"./Racecar-Image-Select/src/scenes/preloader.js": "c972",
	"./Sentence-Parts-Chalkboard/SentencePartsChalkboard": "80c5",
	"./Sentence-Parts-Chalkboard/SentencePartsChalkboard.vue": "80c5",
	"./Sentence-Parts-Chalkboard/src/game": "1d8a",
	"./Sentence-Parts-Chalkboard/src/game.js": "1d8a",
	"./Sentence-Parts-Chalkboard/src/scenes/main": "5e82",
	"./Sentence-Parts-Chalkboard/src/scenes/main.js": "5e82",
	"./Sentence-Parts-Chalkboard/src/scenes/preloader": "ffec",
	"./Sentence-Parts-Chalkboard/src/scenes/preloader.js": "ffec",
	"./Sequencing-Frame/SequencingFrame": "3494",
	"./Sequencing-Frame/SequencingFrame.vue": "3494",
	"./Sequencing-Frame/src/game": "f9a5",
	"./Sequencing-Frame/src/game.js": "f9a5",
	"./Sequencing-Frame/src/scenes/main": "b32c",
	"./Sequencing-Frame/src/scenes/main.js": "b32c",
	"./Sequencing-Frame/src/scenes/preloader": "3252",
	"./Sequencing-Frame/src/scenes/preloader.js": "3252",
	"./Sorting-Platforms/SortingPlatforms": "22ea",
	"./Sorting-Platforms/SortingPlatforms.vue": "22ea",
	"./Sorting-Platforms/src/game": "14a6",
	"./Sorting-Platforms/src/game.js": "14a6",
	"./Sorting-Platforms/src/item": "2e74",
	"./Sorting-Platforms/src/item.js": "2e74",
	"./Sorting-Platforms/src/scenes/main": "2f13",
	"./Sorting-Platforms/src/scenes/main.js": "2f13",
	"./Sorting-Platforms/src/scenes/preloader": "9e1a",
	"./Sorting-Platforms/src/scenes/preloader.js": "9e1a",
	"./Sound-To-Text-Answers/SoundToTextAnswers": "ea62",
	"./Sound-To-Text-Answers/SoundToTextAnswers.vue": "ea62",
	"./Sound-To-Text-Answers/src/game": "f19d",
	"./Sound-To-Text-Answers/src/game.js": "f19d",
	"./Sound-To-Text-Answers/src/scenes/main": "46f9",
	"./Sound-To-Text-Answers/src/scenes/main.js": "46f9",
	"./Sound-To-Text-Answers/src/scenes/preloader": "e5d3",
	"./Sound-To-Text-Answers/src/scenes/preloader.js": "e5d3",
	"./Sounds-Binary/SoundsBinary": "1152",
	"./Sounds-Binary/SoundsBinary.vue": "1152",
	"./Sounds-Binary/src/game": "ed10",
	"./Sounds-Binary/src/game.js": "ed10",
	"./Sounds-Binary/src/scenes/main": "8a37",
	"./Sounds-Binary/src/scenes/main.js": "8a37",
	"./Sounds-Binary/src/scenes/preloader": "4921",
	"./Sounds-Binary/src/scenes/preloader.js": "4921",
	"./Sounds-Multichoice/SoundsMultichoice": "c5f0",
	"./Sounds-Multichoice/SoundsMultichoice.vue": "c5f0",
	"./Sounds-Multichoice/src/game": "6f3d",
	"./Sounds-Multichoice/src/game.js": "6f3d",
	"./Sounds-Multichoice/src/scenes/main": "53aa",
	"./Sounds-Multichoice/src/scenes/main.js": "53aa",
	"./Sounds-Multichoice/src/scenes/preloader": "ebe8",
	"./Sounds-Multichoice/src/scenes/preloader.js": "ebe8",
	"./Sounds-Sorting/SoundsSorting": "6dd7",
	"./Sounds-Sorting/SoundsSorting.vue": "6dd7",
	"./Sounds-Sorting/src/game": "f04f",
	"./Sounds-Sorting/src/game.js": "f04f",
	"./Sounds-Sorting/src/scenes/main": "69c9",
	"./Sounds-Sorting/src/scenes/main.js": "69c9",
	"./Sounds-Sorting/src/scenes/preloader": "fc01",
	"./Sounds-Sorting/src/scenes/preloader.js": "fc01",
	"./shared/about": "39e8",
	"./shared/about.js": "39e8",
	"./shared/answers-counter": "73c7",
	"./shared/answers-counter.js": "73c7",
	"./shared/assets/accuracy-icon.png": "0bec",
	"./shared/assets/brain-icon.png": "08f4",
	"./shared/assets/brain-plus.png": "2d73",
	"./shared/assets/check-mark.png": "7ac3",
	"./shared/assets/cross-mark.png": "bd96",
	"./shared/assets/go-button.png": "66e3",
	"./shared/assets/question-mark.png": "bfe6",
	"./shared/assets/ribbon.png": "460f",
	"./shared/assets/star-disabled.png": "9f10",
	"./shared/assets/star.png": "7b2f",
	"./shared/assets/summary-bg.png": "c474",
	"./shared/assets/thumb/boom.png": "edf4",
	"./shared/assets/thumb/ice-cream.png": "121e",
	"./shared/assets/thumb/thumb-up.png": "86a0",
	"./shared/assets/thumb/wow.png": "e666",
	"./shared/assets/thumb/yes-bl.png": "8679",
	"./shared/assets/thumb/yes-br.png": "4ed1",
	"./shared/assets/thumb/yes-tl.png": "414c",
	"./shared/assets/thumb/yes-tr.png": "f012",
	"./shared/assets/thumb/yes.png": "157d",
	"./shared/assets/time-icon.png": "2f82",
	"./shared/assets/value-bg.png": "dbc1",
	"./shared/base-minigames-scenes/base-main": "f048",
	"./shared/base-minigames-scenes/base-main.js": "f048",
	"./shared/base-minigames-scenes/base-preloader": "4d18",
	"./shared/base-minigames-scenes/base-preloader.js": "4d18",
	"./shared/button": "265c",
	"./shared/button.js": "265c",
	"./shared/cursor-manager": "0e69",
	"./shared/cursor-manager.js": "0e69",
	"./shared/game-kickoff/boot": "a47a",
	"./shared/game-kickoff/boot.js": "a47a",
	"./shared/game-kickoff/game-kickoff-init": "97e9",
	"./shared/game-kickoff/game-kickoff-init.js": "97e9",
	"./shared/game-kickoff/main": "c666",
	"./shared/game-kickoff/main.js": "c666",
	"./shared/game-kickoff/preloader": "8b06",
	"./shared/game-kickoff/preloader.js": "8b06",
	"./shared/globals": "3182",
	"./shared/globals.js": "3182",
	"./shared/ingame-menu": "6f67",
	"./shared/ingame-menu.js": "6f67",
	"./shared/languages": "d21f",
	"./shared/languages.js": "d21f",
	"./shared/main-menu": "89eb",
	"./shared/main-menu.js": "89eb",
	"./shared/mark-animation": "26b3",
	"./shared/mark-animation.js": "26b3",
	"./shared/menu": "2a6b",
	"./shared/menu-button": "f5b5",
	"./shared/menu-button.js": "f5b5",
	"./shared/menu.js": "2a6b",
	"./shared/preloader-background": "bec0",
	"./shared/preloader-background.js": "bec0",
	"./shared/preloader-music": "cce5",
	"./shared/preloader-music.js": "cce5",
	"./shared/question": "d271",
	"./shared/question.js": "d271",
	"./shared/quick-panel": "452e",
	"./shared/quick-panel.js": "452e",
	"./shared/resize": "1e20",
	"./shared/resize.js": "1e20",
	"./shared/summary": "00ae",
	"./shared/summary.js": "00ae",
	"./shared/thumbs-animation": "35ed",
	"./shared/thumbs-animation.js": "35ed",
	"./shared/timer": "1800",
	"./shared/timer.js": "1800"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a18";